import { Component, Input, Output, EventEmitter, Self, Optional, ChangeDetectionStrategy, ViewChild, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Editor } from 'tinymce';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class InputTextComponent implements ControlValueAccessor, OnInit {
  @Input() name = '';
  @Input() showLabel = true;
  @Input() showPlaceholder = true;
  @Input() showError = true;
  @Input() showPassword = false;
  @Input() isTextArea = false;
  @Input() isEditor = false;
  @Input() editorSettings: any;
  @Input() editorMaxLength: number;
  @Input() typeInput: string;
  @Output() focus: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() editorLength = new EventEmitter<number>();

  private innerValue!: string;
  private editor: Editor;
  public disabled = false;
  public isPasswordVisible = false;

  constructor(@Self() @Optional() public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit() {
    this.ngControl.control?.setValidators([this.validate.bind(this)]);
    this.ngControl.control?.updateValueAndValidity();
  }

  get inputType(): string {
    if (this.showPassword && !this.isPasswordVisible) {
      return 'password';
    }
    if (this.typeInput === 'number') {
      return 'number';
    }
    return 'text';
  }

  get hasError(): boolean {
    if (this.showError && this.ngControl.control?.touched && this.ngControl.control?.invalid) {
      return true;
    }
    return false;
  }

  get value(): string {
    return this.innerValue;
  }

  set value(value: string) {
    this.writeValue(value);
    this.onChange(value);
    this.onTouch(value);
  }

  public writeValue(value: string): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onInit(event) {
    this.editor = event.editor;
  }

  validate(AC: AbstractControl) {
    const length = this.editor?.getContent({ format: 'text' }).length;
    if (this.editorMaxLength && length > this.editorMaxLength) {
      return { maxlength: { requiredLength: this.editorMaxLength } };
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: any = () => {};
}
